<template lang="pug">
  v-card
    v-card-title
     h2.card-title {{ isEditMode ? $t('base.edit') : $t('base.add_stock') }}
    v-card-content
      v-text-field.mb-3(
        :focus="true"
        :label="$t('base.name')"
        v-model="form.name")
      v-select(
        :label="$t('base.farm')"
        :options="farmsByCompany"
        :hint="errorMessage('selectedFarm')"
        :invalid="!!errorMessage('selectedFarm')"
        @input="clearError('selectedFarm')"
        v-model="form.farm.id")
    v-card-actions
      v-btn.mr-2(
        :loading="loading"
        :disabled="!form.name || isConsultant"
        @click="onSubmit")
        | {{ isEditMode ? $t('base.save') : $t('base.create') }}
      delete-btn(
        :disabled="isConsultant"
        v-if="isEditMode"
        @delete="onDelete")
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'
import formErrorsMixin from '@/mixins/form-errors.mixin.js'
import DeleteBtn from '@/components/common/delete-btn/DeleteBtn'

export default {
  name: 'DetailModal',
  mixins: [formErrorsMixin],
  components: {
    DeleteBtn
  },

  props: {
    selected: {
      type: Object,
      default: null
    }
  },

  mounted () {
    this.loadFarms()
    if (this.selected) {
      this.form.name = this.selected.name
      if (this.selected.farm) {
        this.form.farm.id = this.selected.farm.id
      }
    }
  },

  data: () => ({
    form: {
      name: null,
      farm: {
        id: null
      },
    },
    errors: {
      selectedFarm: null
    },
    loading: false
  }),

  computed: {
    ...mapGetters('farms', [
      'farms'
    ]),

    isEditMode () {
      return this.selected !== null
    },

    farmsByCompany () {
      return this.farms
        .filter(item => item.company.id === +this.$route.params.company_id)
    }
  },

  methods: {
    ...mapActions('farms', [
      'loadFarms'
    ]),

    async onSubmit () {
      this.loading = true
      const payload = {
        ...this.form,
        company: {
          id: this.$route.params.company_id
        }
      }

      if (!this.checkValidData()) return

      const { errors } = this.isEditMode
        ? await api.stocks.updateById(this.selected.id, payload)
        : await api.stocks.create(payload)
      errors
        ? this.$toasted.error(this.$t('errors.incorrect_data'))
        : this.$emit('close') && this.$emit('update')
      this.loading = false
    },
    checkValidData () {
      const errorCodes = {
        REQUIRED: '4'
      }

      if (!this.form.farm.id) {
        this.errors.selectedFarm = [errorCodes.REQUIRED]
        this.loading = false
        return false
      }
      return true
    },
    async onDelete () {
      await api.stocks.deleteById(this.selected.id)
      this.$emit('update')
      this.$emit('close')
    }
  }
}
</script>
